var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#00838f",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.19,57.34H14.81L16,35.91A15.46,15.46,0,0,1,31.44,21.3h1.83A14.71,14.71,0,0,1,48,35.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.38,21.84,19.72,7.39a.5.5,0,0,1,.52-.73l4.65.77a46,46,0,0,0,14.76.05l5.11-.81a.5.5,0,0,1,.51.75L36.85,21.53"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.23,
    y1: 13.15,
    x2: 30.73,
    y2: 21.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.14,
    y1: 14.79,
    x2: 33.79,
    y2: 21.31,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.42,29.83h2.92c2.85,0,6,.94,6,5.28,0,4.7-4,6.5-8.22,6a.25.25,0,0,0-.2.42l9,9.67",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.77,
    y1: 29.83,
    x2: 27.7,
    y2: 29.83,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.57,
    y1: 35.26,
    x2: 37.84,
    y2: 35.26,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.9494469dab0f6eac5e0e978196900cdb.svg";
export { ForwardRef as ReactComponent };